export default __webpack_public_path__ + "static/media/added_users.60978dbd.svg";